var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tabs === 0)?_c('TabGerarCobranca',{ref:"tabGerarCobranca"}):_vm._e(),(_vm.tabs === 1)?_c('TabMensalista',{ref:"tabMensalista"}):_vm._e(),(_vm.tabs === 2)?_c('TabCobrancaGerada',{ref:"tabCobrancaGerada"}):_vm._e(),(_vm.tabs === 3)?_c('TabTabelaCobranca',{ref:"tabTabelaCobranca"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }